import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

type LockedSectionNoticeProps = {
  title: string;
  message: string;
  ctaLabel: string;
  ctaTo: string;
};

export default function LockedSectionNotice({
  title,
  message,
  ctaLabel,
  ctaTo,
}: LockedSectionNoticeProps) {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto p-6">
      <div className="flex flex-col items-center justify-center py-16 text-center gap-4">
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center">
          <Lock className="w-8 h-8 text-slate-400" />
        </div>
        <h2 className="text-lg font-semibold text-slate-800">{title}</h2>
        <p className="text-sm text-slate-500 max-w-sm">{message}</p>
        <Button onClick={() => navigate(ctaTo)} className="mt-2">
          {ctaLabel}
        </Button>
      </div>
    </div>
  );
}
